import React, {Component} from 'react'
import ReactApexChart from "react-apexcharts"




class ApexRadialright extends Component {
    constructor(props) {
      super(props)
  
      this.state = {
        chart: {
          height: 200,
          type: 'radialBar',
          offsetY: -10
      },
        options: {
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              dataLabels: {
                name: {
                  fontSize: "11px",
                  color: void 0,
                  offsetY: 20,
                },
                value: {
                  offsetY: -20,
                  fontSize: "16px",
                  color: void 0,
                  formatter: function (e) {
                    return e + "%"
                  },
                },
              },
            },
          },
          colors: ["#556ee6"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              shadeIntensity: 0.15,
              inverseColors: !1,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 65, 91],
            },
          },
          stroke: {
            dashArray: 4,
          },
          labels: ["Payment Pending"],
        },
        series: [36],
      }
    }
  
    render() {
      return (
        <React.Fragment>
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="radialBar"
            height="250"
            className='apex-charts'
          />
        </React.Fragment>
      )
    }
  }
  
  export default ApexRadialright